(function() {
    'use strict';

    angular.module('stats')
        .controller('PreviewFavoriteProductsModalController', PreviewFavoriteProductsModalController);

    PreviewFavoriteProductsModalController.$inject = ['lodashService', '$uibModalInstance', 'client', 'previewLoadingConst', 'clientStatsDataSrvc'];

    function PreviewFavoriteProductsModalController(lodashService, $uibModalInstance, client, previewLoadingConst, clientStatsDataSrvc) {
        var self = this;
        self.client = client;
        self.close = close;
        self.previewLoading = true;
        self.pagesLoaded = 0;
        self.pagesLoadingText = previewLoadingConst.pagesLoadingText;
        self.favoriteProducts = [];
        clientStatsDataSrvc.clientFavoriteProducts({pk: client.pk}).$promise.then(
            function(response) {
                self.favoriteProducts = response;
            },
            function(response) {}
        )

        function close() {
            self.client = null;
            $uibModalInstance.close();
        }
    }
})();
